import React from 'react'
import './SubscriberAgreement.scss'

const SubscriberAgreement = () => {
  return (
    <div className="subscriber-container">
      <div className="WordSection1">
        <p className="MsoTitle">
          <a name="_j63412qca6l2" />
          <span lang="EN">Subscriber Agreement</span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Effective date: April 21, 2022
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            Paid subscriptions to ChessX and other services on this site are governed by the
            following terms and agreement:
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_k46eg1c1y0l3" />
          <b>
            <span lang="EN" style={{ fontSize: '16.5pt', lineHeight: '115%', color: '#312E2B' }}>
              Payments
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            Payments for subscriptions can be made via credit card, PayPal, iTunes, Google Play,
            money order, or other payment methods. All subscriptions are processed in US dollars
            unless otherwise shown.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            Gift subscriptions are charged once only and do not renew. All other subscriptions are
            auto-renewed until canceled by the subscriber through their account, or by contacting
            contact@chessx.app. Payments made by mail should identify the subscription product and
            should be sent to <b>137 Erie Street, Cambridge, MA 02139</b>. Please see our Privacy
            Policy for further information regarding our use and storage of payment information.
            This Subscriber Agreement is subject to any limitations set forth in the Privacy Policy.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_9bekf3kn5gnn" />
          <b>
            <span lang="EN" style={{ fontSize: '16.5pt', lineHeight: '115%', color: '#312E2B' }}>
              Services
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            Subscribers are authorized to receive the services outlined on the subscription page for
            the duration of their subscription. Services are effective immediately upon receipt of
            payment. As with any online subscription service, we cannot guarantee that ChessX or any
            of the Service will be free of downtime for maintenance or other outages. Where
            possible, we may notify you in advance of planned outages.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_cfwuqjlg6aky" />
          <b>
            <span lang="EN" style={{ fontSize: '16.5pt', lineHeight: '115%', color: '#312E2B' }}>
              Upgrades/Downgrades
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            Upgrading can be done at any time and the upgrade price will be prorated according to
            the time used and time remaining. The upgrade price will show in the checkout process.
            Downgrades are not available until after the expiration of the original subscription.
            For help, please contact us at contact@chessx.app.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_gi590cfw0zrc" />
          <b>
            <span lang="EN" style={{ fontSize: '16.5pt', lineHeight: '115%', color: '#312E2B' }}>
              Refunds
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            If you are not satisfied, please contact us at contact@chessx.app. All first-time credit
            card and Android subscriptions are given a 30-Day Money Back Guarantee. Refunds will NOT
            be given to subscribers who are banned from the site due to violating the Terms and
            Conditions of site use (abusive behavior, cheating, etc).
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            Subscribers via iTunes are subject to Apple&apos;s Subscription terms. Unfortunately,
            Apple does not provide a way for ChessX to refund iTunes payments, and all refunds and
            claims must be made directly via Apple. Please see{' '}
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#1155CC' }}>
            <a href="https://support.apple.com/en-us/HT202039">
              <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                https://support.apple.com/en-us/HT202039
              </span>
            </a>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            .
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            If you have any questions regarding the above policies please contact us at
            contact@chessx.app.
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN">&nbsp;</span>
        </p>
      </div>
    </div>
  )
}

export default SubscriberAgreement
